"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCheckBoxes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../../styles");
const getRadioCheckBoxes = (variants) => variants.map((variant, idx) => {
    if (!variant)
        return;
    const { variant: { bigcommerceId: variant_id }, currentVariantId, setCurrentVariant, text } = variant;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { id: idx, onChange: () => { setCurrentVariant(variant.variant); }, type: 'radio', checked: variant_id === currentVariantId }), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: idx }, { children: text }))] }, idx));
});
exports.RadioCheckBoxes = (0, react_1.memo)(({ data }) => {
    const InputRadios = (0, react_1.useMemo)(() => getRadioCheckBoxes(data), [data]);
    return ((0, jsx_runtime_1.jsx)(RadioButtonWrapper, { children: InputRadios }));
});
const RadioButtonWrapper = styled_components_1.default.div `
  span {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.red};
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
    display: flex;
    height: ${(0, styles_1.vw)(27, 'mobile')};
    justify-content: center;
    margin-right: ${(0, styles_1.vw)(10, 'mobile')};
    pointer-events: none;
    position: relative;
    user-select: none;
    width: ${(0, styles_1.vw)(25, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(27, 'nexus7')};
      margin-right: ${(0, styles_1.vw)(10, 'nexus7')};
      width: ${(0, styles_1.vw)(25, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(27, 'desktop')};
      margin-right: ${(0, styles_1.vw)(10, 'desktop')};
      width: ${(0, styles_1.vw)(25, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 27px;
      margin-right: 10px;
      width: 25px;
    }

    &:before {
      background-color: ${({ theme }) => theme.colors.white};
      clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%);
      content: ' ';
      display: none;
      height: ${(0, styles_1.vw)(24, 'mobile')};
      width: ${(0, styles_1.vw)(22, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(24, 'nexus7')};
        width: ${(0, styles_1.vw)(22, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(24, 'desktop')};
        width: ${(0, styles_1.vw)(22, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 24px;
        width: 22px;
      }
    }

    &:after {
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: 50%;
      content: ' ';
      height: ${(0, styles_1.vw)(10, 'mobile')};
      position: absolute;
      width: ${(0, styles_1.vw)(10, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(10, 'nexus7')};
        width: ${(0, styles_1.vw)(10, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(10, 'desktop')};
        width: ${(0, styles_1.vw)(10, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 10px;
        width: 10px;
      }
    }
  }

  label {
    white-space: nowrap;
    cursor: pointer;

  }

  input:not(:checked) + span::before {
    display: block;
  }
`;
